var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tabs",
    {
      staticClass: "ori-uni-notes-drawer",
      attrs: { type: "border-card" },
      model: {
        value: _vm.noteActiveTab0,
        callback: function ($$v) {
          _vm.noteActiveTab0 = $$v
        },
        expression: "noteActiveTab0",
      },
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { name: "subject" } },
        [
          _c("span", { attrs: { slot: "label" }, slot: "label" }, [
            _c("i", { staticClass: "iconfont iconmulu1" }),
            _vm._v(" 目录 "),
          ]),
          _c("Catalog", {
            ref: "catalog",
            attrs: { lessonsUuidPr: _vm.lessonsUuid, datas: _vm.sectionDtos },
            on: { change: _vm.lessonChange },
          }),
        ],
        1
      ),
      _c("el-tab-pane", { attrs: { name: "note" } }, [
        _c("span", { attrs: { slot: "label" }, slot: "label" }, [
          _c("i", { staticClass: "iconfont icontousujianyi" }),
          _vm._v(" 笔记 "),
        ]),
        _c(
          "div",
          { staticClass: "ej-tab" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.noteTabChange },
                model: {
                  value: _vm.noteActiveTab2,
                  callback: function ($$v) {
                    _vm.noteActiveTab2 = $$v
                  },
                  expression: "noteActiveTab2",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "我的笔记", name: "myNote" } },
                  [
                    _c("div", { staticClass: "notes-pane" }, [
                      _c(
                        "div",
                        { attrs: { id: "noteEdit" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "输入笔记内容",
                              type: "textarea",
                              rows: "5",
                              maxlength: "200",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.noteContent,
                              callback: function ($$v) {
                                _vm.noteContent = $$v
                              },
                              expression: "noteContent",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "note-refer" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "note-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.addNotes },
                            },
                            [_vm._v("记笔记")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { "true-label": 1, "false-label": 0 },
                              model: {
                                value: _vm.isPublic,
                                callback: function ($$v) {
                                  _vm.isPublic = $$v
                                },
                                expression: "isPublic",
                              },
                            },
                            [_vm._v("公开")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "ul",
                        { staticClass: "note-lists mat50" },
                        _vm._l(_vm.myNotes, function (item) {
                          return _c(
                            "li",
                            { key: item.id, staticClass: "item" },
                            [
                              _c("p", { staticClass: "date" }, [
                                _c("span", [_vm._v(_vm._s(item.created_at))]),
                                _c("span", [
                                  _c("i", {
                                    staticClass: "iconfont iconjibiji",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editMyNoteHandler(item)
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass: "iconfont iconshanchu",
                                    attrs: { slot: "reference" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteNote(item.id)
                                      },
                                    },
                                    slot: "reference",
                                  }),
                                ]),
                              ]),
                              _c("div", {
                                staticClass: "con",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$xss(
                                      item.content.replace(/\n/g, "<br/>")
                                    )
                                  ),
                                },
                              }),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "text-align": "right",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        "true-label": 1,
                                        "false-label": 0,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.updateIsPublic(item)
                                        },
                                      },
                                      model: {
                                        value: item.is_open,
                                        callback: function ($$v) {
                                          _vm.$set(item, "is_open", $$v)
                                        },
                                        expression: "item.is_open",
                                      },
                                    },
                                    [_vm._v("公开")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "大家的笔记", name: "otherNote" } },
                  [
                    _c("div", { staticClass: "notes-pane" }, [
                      _c(
                        "ul",
                        { staticClass: "note-lists" },
                        _vm._l(_vm.othersNotes, function (item) {
                          return _c(
                            "li",
                            { key: item.uuid, staticClass: "item" },
                            [
                              _c(
                                "div",
                                { staticClass: "other-date" },
                                [
                                  _c(
                                    "el-image",
                                    {
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                        "border-radius": "50%",
                                        "margin-right": "10px",
                                      },
                                      attrs: {
                                        src: item.student_thumb,
                                        fit: "cover",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          slot: "error",
                                          src: require("@/assets/images/headEmpty.png"),
                                          alt: "暂无头像",
                                        },
                                        slot: "error",
                                      }),
                                    ]
                                  ),
                                  _c("div", [
                                    _c("p", [
                                      _vm._v(_vm._s(item.student_title)),
                                    ]),
                                    _c("p", { staticClass: "gray-light" }, [
                                      _vm._v(_vm._s(item.created_at)),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", {
                                staticClass: "con",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$xss(
                                      item.content.replace(/\n/g, "<br/>")
                                    )
                                  ),
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("el-tab-pane", { attrs: { name: "teacher" } }, [
        _c("span", { attrs: { slot: "label" }, slot: "label" }, [
          _c("i", {
            staticClass: "el-icon-postcard",
            staticStyle: { "font-size": "16px" },
          }),
          _vm._v(" 老师简介 "),
        ]),
        _vm.teacherDatas && _vm.teacherDatas.content
          ? _c(
              "div",
              {
                staticStyle: {
                  "text-indent": "2em",
                  "line-height": "30px",
                  "text-align": "justify",
                },
              },
              [_vm._v(" " + _vm._s(_vm.teacherDatas.content) + " ")]
            )
          : _c(
              "div",
              {
                staticStyle: {
                  "text-indent": "2em",
                  "line-height": "30px",
                  "text-align": "justify",
                },
              },
              [_vm._v("暂无简介")]
            ),
        _c("div", { staticClass: "answer-box" }),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改笔记",
            visible: _vm.isEditVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isEditVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { attrs: { id: "noteEdit" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "输入笔记内容",
                  type: "textarea",
                  rows: "5",
                },
                model: {
                  value: _vm.editMyNote.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.editMyNote, "content", $$v)
                  },
                  expression: "editMyNote.content",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "note-refer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "note-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.updateNotes },
                },
                [_vm._v("修改笔记")]
              ),
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 1, "false-label": 0 },
                  model: {
                    value: _vm.editMyNote.is_open,
                    callback: function ($$v) {
                      _vm.$set(_vm.editMyNote, "is_open", $$v)
                    },
                    expression: "editMyNote.is_open",
                  },
                },
                [_vm._v("公开")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }